import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    pageIndex: 1,
    pageSize: 10,
    globalSearch: "",
    sorting: null,
    state: null,
  },
  sortedColumn: null,
  sortedDirection: null,
  reportList: [],
  isLoadingReports: false,
};

const gestioneReportSlice = createSlice({
  name: "gestioneReportSlice",
  initialState,
  reducers: {
    setIsLoadingReports: (state: any, action) => {
      state.isLoadingReports = action.payload;
    },
    setReports: (state: any, action: any) => {
      state.reportList = [...action.payload];
    },
    nextPageReports: (state) => {
      state.filters.pageIndex++;
    },
    setPageReportsAndSize: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: action.payload.page ?? state.filters.pageIndex,
        pageSize: action.payload.size ?? state.filters.pageSize,
      });
    },
    setPageReports: (state, action) => {
      state.filters.pageIndex = action.payload;
    },
    setSizeReports: (state, action) => {
      state.filters.pageSize = action.payload;
    },
    setSearchTermReports: (state, action) => {
      Object.assign(state.filters, {
        pageIndex: 1,
        globalSearch: action.payload,
      });
    },

    setSortingReports: (state, action) => {
      state.sortedColumn = action.payload.sortedColumn;
      state.sortedDirection = action.payload.sortedDirection;
      Object.assign(state.filters, {
        pageIndex: 1,
        sorting: action.payload.sorting,
      });
    },
    setReportsState: (state, action) => {
      Object.assign(state.filters, { pageIndex: 1, state: action.payload });
    },
    resetFiltersReports: () => {
      return initialState;
    },
  },
});

export const {
  nextPageReports,
  setPageReports,
  setSizeReports,
  setSearchTermReports,
  setSortingReports,
  resetFiltersReports,
  setReports,
  setPageReportsAndSize,
  setIsLoadingReports,
  setReportsState,
} = gestioneReportSlice.actions;

export default gestioneReportSlice.reducer;
